import { Box, TextField } from "@mui/material/";

import "./../genericModels.css";
import { DateTimePicker } from "@mui/x-date-pickers";

import { useTranslation } from "react-i18next";
import GenericFilterBoxWithoutTenant from "../common/GenericFilterBoxWithoutTenant";
import { Autocomplete } from "@mui/material";
import { useMemo, useState } from "react";
import { vehicleTsSearchActions } from "../../service/vehicleTsSearchActions";

export const VehicleTsSearchFilterAndSearch = (props: any) => {
  const [statusList, setStatusList] = useState<any>([]);

  let dataFormSearchFieldImportTracking = props.dataFormSearchFieldImportTracking;
  let setDataFormSearchFieldImportTracking = props.setDataFormSearchFieldImportTracking;
  let resetFormTextImportTracking = props.resetFormTextImportTracking;
  console.log(resetFormTextImportTracking, "resetFormTextImportTracking");

  const { t } = useTranslation(["operation"]);

  const changeStatusName = (statusName: string) => {
    switch (statusName) {
      case "PROCESSED":
        return t("vehicleTsSearch.statusType.processed");
      case "PROCESSING":
        return t("vehicleTsSearch.statusType.processing");
      case "FAILED":
        return t("vehicleTsSearch.statusType.failed");
      default:
        return "";
    }
  };

  const Search = (e: any) => {
    e.preventDefault();
    props.setResetFormValueImportTracking(!props.resetFormValueImportTracking);
  };

  useMemo(() => {
    vehicleTsSearchActions()
      .statusList()
      .then((response) => setStatusList(response));
  }, []);

  return (
    <>
      <form id="idTsVehicleForm" onSubmit={(e) => Search(e)}>
        <GenericFilterBoxWithoutTenant
          formId="idTsVehicleForm"
          onReset={resetFormTextImportTracking}
          showExtrasFilters={true}
        >
          <Box>
            <TextField
              fullWidth
              label={t("vehicleTsSearch.vin")}
              variant="standard"
              id="vin"
              name="vin"
              value={dataFormSearchFieldImportTracking.vin}
              onChange={(e: any) =>
                setDataFormSearchFieldImportTracking({
                  ...dataFormSearchFieldImportTracking,
                  vin: e.target.value,
                })
              }
            />
          </Box>
          <Box>
            <TextField
              fullWidth
              label={t("vehicleTsSearch.imei")}
              variant="standard"
              id="imei"
              name="imei"
              value={dataFormSearchFieldImportTracking.imei}
              onChange={(e: any) =>
                setDataFormSearchFieldImportTracking({
                  ...dataFormSearchFieldImportTracking,
                  imei: e.target.value,
                })
              }
            />
          </Box>
          <Box>
            <TextField
              fullWidth
              label={t("vehicleTsSearch.voucherNumber")}
              variant="standard"
              id="voucherNumber"
              name="voucherNumber"
              value={dataFormSearchFieldImportTracking.voucherNumber}
              onChange={(e: any) =>
                setDataFormSearchFieldImportTracking({
                  ...dataFormSearchFieldImportTracking,
                  voucherNumber: e.target.value,
                })
              }
            />
          </Box>
          <Box>
            <TextField
              fullWidth
              label={t("vehicleTsSearch.packageCode")}
              variant="standard"
              id="packageCode"
              name="packageCode"
              value={dataFormSearchFieldImportTracking.packageCode}
              onChange={(e: any) =>
                setDataFormSearchFieldImportTracking({
                  ...dataFormSearchFieldImportTracking,
                  packageCode: e.target.value,
                })
              }
            />
          </Box>
          {/*        
          <Box>
            <TextField
              fullWidth
              label={t("vehicleTsSearch.supplier")}
              variant="standard"
              id="supplier"
              name="supplier"
              value={dataFormSearchFieldImportTracking.supplier}
              onChange={(e: any) =>
                setDataFormSearchFieldImportTracking({
                  ...dataFormSearchFieldImportTracking,
                  supplier: e.target.value,
                })
              }
            />
          </Box>
          */}
          <Box>
            <DateTimePicker
              label={t("vehicleTsSearch.creationDateFrom")}
              value={dataFormSearchFieldImportTracking.creationDateFrom}
              onChange={(e) => {
                setDataFormSearchFieldImportTracking({
                  ...dataFormSearchFieldImportTracking,
                  creationDateFrom: e,
                });
              }}
              mask={"__/__/____ __:__"}
              inputFormat={"DD/MM/YYYY HH:mm"}
              ampm={false}
              renderInput={(params) => (
                <TextField
                  variant="standard"
                  fullWidth
                  {...params}
                  name="creationDateFrom"
                />
              )}
            />
          </Box>
          <Box>
            <DateTimePicker
              label={t("vehicleTsSearch.creationDateTo")}
              value={dataFormSearchFieldImportTracking.creationDateTo}
              onChange={(e) => {
                setDataFormSearchFieldImportTracking({
                  ...dataFormSearchFieldImportTracking,
                  creationDateTo: e,
                });
              }}
              mask={"__/__/____ __:__"}
              inputFormat={"DD/MM/YYYY HH:mm"}
              ampm={false}
              renderInput={(params) => (
                <TextField
                  variant="standard"
                  fullWidth
                  {...params}
                  name="creationDateTo"
                />
              )}
            />
          </Box>
          
          {
          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable={
                !!dataFormSearchFieldImportTracking.processingStatus ? false : true
              }
              id="processingStatus"
              value={dataFormSearchFieldImportTracking.processingStatus ?? ""}
              options={statusList?.map((response: any) => response)}
              getOptionLabel={(option: any) => changeStatusName(option)}
              onChange={(e, value) => {
                if (e === null) {
                  setDataFormSearchFieldImportTracking({
                    ...dataFormSearchFieldImportTracking,
                    processingStatus: "",
                  });
                  props.SearchImportTracking();
                } else {
                  setDataFormSearchFieldImportTracking({
                    ...dataFormSearchFieldImportTracking,
                    processingStatus: value,
                  });
                }
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("vehicleTsSearch.placeholderStatus")}
                />
              )}
              renderOption={(props, option, state) => {
                return (
                  <li {...props} key={props.id}>
                    {changeStatusName(option)}
                  </li>
                )
              }}
            />
          </Box>
          }
        </GenericFilterBoxWithoutTenant>
      </form>
    </>
  );
};
